/**
 * PoweredByFooter — white-label attribution footer for all external portal pages.
 *
 * Always rendered regardless of tenant theme. Styled subtly so it doesn't
 * compete with tenant branding while maintaining BuildGravity attribution.
 */
export function PoweredByFooter() {
  return (
    <footer
      className="mt-8 py-4 border-t text-center"
      style={{ borderColor: 'var(--border, #e5e7eb)' }}
    >
      <p className="text-xs" style={{ color: 'var(--muted-foreground, #6b7280)' }}>
        Powered by{' '}
        <a
          href="https://buildgravity.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
          style={{ color: 'var(--muted-foreground, #6b7280)' }}
        >
          BuildGravity
        </a>
      </p>
    </footer>
  );
}
